import React, { useState } from "react";
import { useProductGroupCategory } from "../../../api/product-group-category/use-product-group-category";
import Button from "../../../components/ui/Button/Button";
import { Dropdown } from "../../../components/ui/Dropdown/Dropdown";
import InputDate from "../../../components/ui/InputDate/InputDate";
import InputSearch from "../../../components/ui/InputSearch/InputSearch";

function Filter(props) {
  const { onFilter, onSubmitFilter, onResetFilter } = props;

  return (
    <div
      style={{
        boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.16)",
      }}
      className="mt-3 rounded-[4px]"
    >
      <div className="flex items-center px-5 pt-5 pb-[10px]">
        <div className="flex items-center">
          <span className="w-24">등록 상태</span>
          <div className="flex gap-6">
            <div className="flex gap-1 items-center">
              <>
                <input
                  type="radio"
                  className="flex-none accent-primary-black"
                  id="all"
                  value=""
                  name="status"
                  onChange={(event) => onFilter({ status: event.target.value })}
                />
                <label htmlFor="all">전체</label>
              </>
            </div>
            <div className="flex gap-1 items-center">
              <>
                <input
                  type="radio"
                  className="flex-none accent-primary-black"
                  id="ongoing"
                  value="ON"
                  name="status"
                  onChange={(event) => onFilter({ status: event.target.value })}
                />
                <label htmlFor="ongoing">사용중</label>
              </>
            </div>
            <div className="flex gap-1 items-center">
              <>
                <input
                  type="radio"
                  className="flex-none accent-primary-black"
                  id="finished"
                  value="OFF"
                  name="status"
                  onChange={(event) => onFilter({ status: event.target.value })}
                />
                <label htmlFor="finished">사용안함</label>
              </>
            </div>
          </div>
        </div>
      </div>

      <div className={`flex items-center px-5 pt-2 pb-5`}>
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center w-1/2">
            <span className="w-24">검색</span>
            <div className="flex gap-4">
              <InputSearch
                width="w-[18rem]"
                onChange={(value) => onFilter({ title: value })}
                placeholder="배너 제목을 검색"
              />
            </div>
          </div>

          <div className="flex items-center gap-[8px] w-1/2">
            <span className="w-12">기간</span>
            <InputDate
              onChange={(value) =>
                onFilter({
                  from: value?.unix() * 1000,
                })
              }
              //   className="w-24 h-10"
              placeholder="날짜선택"
            />
            <span className="text-[#bbbbbb]">-</span>
            <InputDate
              onChange={(value) =>
                onFilter({
                  to: value?.unix() * 1000,
                })
              }
              //   className="w-24 h-10"
            />
          </div>
        </div>
      </div>
      <div className="pb-2.5 w-full border-t border-disable-grey " />
      <div className="pb-2.5 flex justify-center items-center">
        <Button
          onClick={onSubmitFilter}
          className="border border-secondary-grey"
          paddingButton="p-1"
          width="w-[7rem]"
          text="필터 검색"
        />

        <Button
          onClick={onResetFilter}
          className="border border-secondary-grey"
          text="필터 초기화"
          width="w-[7rem]"
          paddingButton="p-1"
        />
      </div>
    </div>
  );
}

export default Filter;
